import { sessionGuard } from '@core/guards/session.guard';
import { environment } from '@env/environment';

/**
 * Guards applied to every authenticated feature route. The `noExternalAuth`
 * debug flag keeps local development on the `sign-in-dev` endpoint, where no
 * identity provider session exists at all, so the session check is skipped.
 */
export const guards = environment.debugFlags.includes('noExternalAuth') ? [] : [sessionGuard];
